import clsx from "clsx";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { TextInput } from "../../TextInput";
import useValidation from "../../validation/useValidation";
import { SearchCriterion } from "../common/SearchCriterion";
import { requiredRolesType } from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";

interface FreeTextCriterionProps {
	criterionKey: string;
	customValidation?: () => void;
	label: string;
	placeholder?: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	visibilitySelector?: visibilitySelectorType;
}

export const FREE_TEXT_CRITERION_INITIAL_STATE = "";

export function FreeTextCriterion({
	criterionKey,
	label,
	requiredRoles,
	placeholder,
	prefix,
	quickSearch = false,
	visibilitySelector,
}: FreeTextCriterionProps) {
	const { currentInput, onInputChange } = useFormComponentState(
		criterionKey,
		FREE_TEXT_CRITERION_INITIAL_STATE,
	);
	const { valid, message } = useValidation(criterionKey);

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			requiredRoles={requiredRoles}
			quickSearch={quickSearch}
			visibilitySelector={visibilitySelector}
		>
			<div className={clsx("criterion input-field", { error: !valid })}>
				<TextInput
					name={label}
					id={`${criterionKey}${quickSearch ? "_quick_search" : ""}`}
					label={label}
					value={currentInput}
					placeholder={placeholder}
					prefix={prefix}
					error={message}
					onChange={(e) => onInputChange(e.target.value)}
				/>
			</div>
		</SearchCriterion>
	);
}
